import React, { useState } from "react";
import {
  ButtonCancel,
  ModalConf,
  ButtonConfirm,
  Loading,
} from "./ModalConfirm.styled";
import { ModalWarn } from "../ModalWarning/ModalWarning.styled";
import ConfirmWarning from "./ConfirmWarning";
import { Spin } from "antd";
import NotAcceptedWarning from "../ModalWarning/NotAcceptedWarning";
import AcceptedInfo from "./AcceptedInfo";

export default function ModalConfirm({
  show,
  isCancel,
  confirm,
  connectName,
  statusConfirm,
  confirmError,
  data,
}) {
  const [vis, setVis] = useState(false);
  const showModal = () => {
    setVis(true);
  };

  const handleCancel = () => {
    setVis(false);
  };

  return (
    <>
      <ModalConf
        visible={show}
        maskClosable={false}
        centered
        closable={false}
        footer={[
          <ButtonCancel key="submit" onClick={isCancel}>
            Изменить
          </ButtonCancel>,
          <ButtonConfirm
            key="confirm"
            htmlType="submit"
            onClick={() => {
              confirm();
              showModal();
            }}
          >
            Подтвердить
          </ButtonConfirm>,
        ]}
      >
        <ConfirmWarning connectName={connectName} data={data} />
        {statusConfirm === "loading" ? (
          <Loading>
            <Spin />
          </Loading>
        ) : null}
      </ModalConf>
      {statusConfirm === "error" ? (
        <ModalWarn
          visible={vis}
          maskClosable={false}
          centered
          closable={false}
          footer={[
            <ButtonCancel key="submit" onClick={handleCancel}>
              Закрыть
            </ButtonCancel>,
          ]}
        >
          <NotAcceptedWarning
            connectName={connectName}
            confirmError={confirmError}
            data={data}
          />
        </ModalWarn>
      ) : statusConfirm === "success" ? (
        <ModalWarn
          visible={vis}
          maskClosable={false}
          centered
          closable={false}
          footer={[
            <ButtonCancel key="submit" onClick={handleCancel}>
              Закрыть
            </ButtonCancel>,
          ]}
        >
          <AcceptedInfo
            connectName={connectName}
            confirmError={confirmError}
            data={data}
          />
        </ModalWarn>
      ) : null}
    </>
  );
}
